import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_DONE,
  GET_CATEGORY_VIDEOS_REQUEST,
  GET_CATEGORY_VIDEOS_SUCCESS,
  GET_CATEGORY_VIDEOS_ERROR,
} from "./actions";

const initialState = {
  categoriesRequesting: false,
  categoriesSuccessful: false,
  categoryVideosRequesting: false,
  categoryVideosSuccessful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORIES_REQUEST:
      return {
        categoriesRequesting: true,
        categoriesSuccessful: false,
        categories: undefined,
        categoriesError: undefined,
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        categoriesRequesting: false,
        categoriesSuccessful: true,
        categories: action.categories,
        categoriesError: undefined,
      };

    case GET_CATEGORIES_ERROR:
      return {
        categoriesRequesting: false,
        categoriesSuccessful: false,
        categories: undefined,
        categoriesError: action.error,
      };

    case GET_CATEGORIES_DONE:
      return {
        ...initialState,
        categoriesSuccessful: state.categoriesSuccessful,
        categories: state.categories,
      };

    case GET_CATEGORY_VIDEOS_REQUEST:
      return {
        ...state,
        categoryVideosRequesting: true,
        categoryVideosSuccessful: false,
        videos: undefined,
        categoryVideosError: undefined,
      };

    case GET_CATEGORY_VIDEOS_SUCCESS:
      // console.log('<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>', action.videos)
      return {
        ...state,
        categoryVideosRequesting: false,
        categoryVideosSuccessful: true,
        videos: action.videos,
        categoryVideosError: undefined,
      };

    case GET_CATEGORY_VIDEOS_ERROR:
      return {
        ...state,
        categoryVideosRequesting: false,
        categoryVideosSuccessful: false,
        videos: undefined,
        categoryVideosError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/video-chooser/reducer.js